export const rosterTour = 'roster-tour';
export const detailTour = 'detail-tour';

export enum TourStepStatus {
  SKIPPED = 'skipped',
  COMPLETED = 'completed',
}
